import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import Box, { BoxProps } from 'ui-box';
import { Spinner } from '../../npaper';
import { useStores } from '../../stores';
import {
  ITimelineLog,
  ITimelineLogSnapshotIn,
  TimelineLog,
} from '../../stores/TimelineLog';
import { TimeLineItem } from './TimeLineItem';

export interface ITimeLineProps extends BoxProps<'div'> {
  timelineBaseUrl: string;
}

export const TimeLine: React.FC<ITimeLineProps> = ({ timelineBaseUrl }) => {
  const { authStore } = useStores();
  const [results, setResults] = useState<ITimelineLog[]>();

  useEffect(() => {
    let isSub = true;

    authStore.env.api
      .get<ITimelineLogSnapshotIn[]>(timelineBaseUrl)
      .then((res) => {
        if (isSub) {
          const logs = res.data.map((d) => TimelineLog.create(d));
          setResults(logs);
        }
      });

    return () => {
      isSub = false;
    };
  }, [authStore.env.api, timelineBaseUrl]);

  return (
    <Box className="time-line">
      {results ? (
        results.length === 0 ? (
          <p className="muted">
            <FormattedMessage defaultMessage="No logs were found" />
          </p>
        ) : (
          results.map((log) => <TimeLineItem key={log.id} timelineLog={log} />)
        )
      ) : (
        <Spinner size={16} />
      )}
    </Box>
  );
};
